import cn from 'classnames'
import { HTMLAttributes, MouseEvent, useEffect, useState } from 'react'

import styles from './AssetsInputPreview.module.scss'

import CloseSmallIcon from '~icons/close-small.svg'
import Image from '~lib/ui-kit/Image'
import Text from '~lib/ui-kit/Text'

export type AssetsInputPreviewProps = HTMLAttributes<HTMLDivElement> & {
  disabled?: boolean
  name?: string
  index?: number
  detailed?: boolean
  loading?: boolean
  readOnly?: boolean
  url?: File | string
  onRemove?: (index: number) => void
  onClickAsset?: (index: number) => void
}

function AssetsInputPreview({
  disabled,
  name = '',
  index,
  detailed,
  loading,
  readOnly,
  url,
  className,
  onClickAsset,
  onRemove,
  ...elemProps
}: AssetsInputPreviewProps) {
  const [src, setSrc] = useState<string | undefined>(() => (typeof url === 'string' ? url : undefined))

  useEffect(() => {
    const objUlr = url instanceof File ? URL.createObjectURL(url) : undefined
    setSrc(typeof url === 'string' ? url : objUlr)

    return (): void => {
      if (objUlr) {
        URL.revokeObjectURL(objUlr)
      }
    }
  }, [url])

  function handleRemove(e: MouseEvent<HTMLButtonElement>): void {
    e.stopPropagation()
    onRemove?.(index)
  }

  function handleClick(e: MouseEvent<HTMLButtonElement>): void {
    e.stopPropagation()
    onClickAsset?.(index)
  }

  return (
    <div className={cn(styles.root, className)} {...elemProps}>
      <button type="button" onClick={handleClick}>
        <Image
          size="fit"
          alt={name}
          loading={loading}
          src={src}
          detailed={detailed}
          asset
          bordered
          renderAlt={(alt) => {
            return (
              <Text as="div" variant="secondary" bold className={styles.alt}>
                {alt.length > 24 ? `${alt.slice(0, 12)}...${alt.slice(-9)}` : alt}
              </Text>
            )
          }}
        />
      </button>
      {!readOnly && !disabled && !loading && (
        <button type="button" className={styles.remove} onClick={handleRemove}>
          <CloseSmallIcon />
        </button>
      )}
    </div>
  )
}

export default AssetsInputPreview
